<template>
  <section
    :id="`${cms.scroll_id}`"
    v-editable="cms"
    :class="[name]"
    :style="mainCssVars"
  >
    <grid
      :class="['grid--container', `${name}__grid`]"
      :layout="[
        {
          size: 1,
          columns: 'repeat(12, 1fr)',
          alignContent: 'center',
          gap: '6px',
        },
        {
          size: 2,
          columns: 'repeat(24, 1fr)',
          gap: '10px',
          alignContent: 'center',
        },
      ]"
    >
      <grid-item
        :class="`${name}__grid-item`"
        :layout="[
          { size: 1, x: 1, width: 12 },
          { size: 3, x: 4, width: 18 },
        ]"
      >
        <a-heading v-if="cms.heading" :cms="cms" :class="`${name}__header`" />
        <div :class="`${name}__collection`">
          <div
            v-for="(item, index) in cms.collection"
            :key="index"
            :class="[`${name}__item`]"
          >
            <a-image-v2
              v-if="(item.image || {}).filename"
              :src="item.image.filename"
              :alt="item.image.alt"
              :layout="layout"
              :class="`${name}__image`"
            />
            <a-heading :cms="item" :class="`${name}__content`" html-tag="h4" />
          </div>
        </div>
      </grid-item>
    </grid>
  </section>
</template>

<script>
import Colors from '~/mixins/colors'
import data from '~/components/organisms/o-features/o-features.data'

export default {
  mixins: [Colors],
  props: {
    cms: {
      type: Object,
      default() {
        const config = {}
        return process.env.NODE_ENV === 'development'
          ? { ...data, ...config }
          : config
      },
    },
    layout: {
      type: Array,
      default() {
        return [{ size: 0, bound: 313, ratio: [216, 216] }]
      },
    },
  },

  data() {
    return {
      name: 'o-features-v2',
    }
  },

  computed: {
    spacing() {
      return this.cms.spacing
    },
    mainCssVars() {
      return {
        '--bg-color': this.setColor(
          (this.cms.color_background || {}).color || '#FFFFFF',
          this.cms.color_gradient
        ),
        '--text-color': this.setColor(
          (this.cms.color_text || {}).color || '#000000'
        ),
        '--hover-color': this.setColor(
          (this.cms.color_hover || {}).color || '#C33CA8'
        ),
        '--bg-color-card': this.setColor(
          (this.cms.color_card_background || {}).color || '#FFFFFF'
        ),
        '--spacing-top': this.cms.spacing_top || '100px',
        '--spacing-bottom': this.cms.spacing_bottom || '100px',
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.o-features-v2 {
  transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out,
    border 0.2s ease-in-out;
  background: var(--bg-color);
  border-color: var(--text-color);
  color: var(--text-color);
  padding: var(--spacing-top) 0 var(--spacing-bottom);

  ::v-deep a,
  ::v-deep .a-cta {
    color: var(--text-color);
    &:hover,
    &:active {
      color: var(--hover-color);
    }
    &:disabled,
    &.disabled {
      color: var(--disabled-color);
    }
  }

  .grid {
    min-height: inherit;
    display: grid;
    align-content: center;
  }

  &__collection {
    display: grid;
    grid-gap: 10px;
  }

  &__item {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    grid-gap: 6px;
    padding: 30px 0;
    background: var(--bg-color-card);
  }

  &__image {
    grid-column: 2/ 4;
    max-width: 60px;
  }

  &__header {
    @include font-family($headings-font-family, 600);
    @include font-size(36, 40.8px);

    padding-top: 0;
  }

  &__content {
    grid-column: 5/ -2;
    margin: 0;
    align-self: center;
    ::v-deep &.a-heading {
      @include font-family($font-family-headings, 600);
      @include font-size(16, 28px);
    }
  }
}

@include media-breakpoint-up(md) {
  .o-features-v2 {
    &__collection {
      grid-template-columns: repeat(2, 1fr);
    }
  }
}
</style>
